"use client";

import { useBounceToAppTap } from "@/lib/inAppEscape/InAppEscapeContext";
import { STORE_BADGE_CLASS } from "./RedirectDestinationActions";

/**
 * The tap opens the app, or the store when the app is missing. The href is
 * only for a page whose scripts did not run. See useAppBounce.
 */
export function OpenAppButton({ iosUrl }: { iosUrl: string }) {
  const onOpenAppTap = useBounceToAppTap();

  return (
    <a href={iosUrl} onClick={onOpenAppTap} className={STORE_BADGE_CLASS}>
      <span className="text-lg font-semibold">Open app</span>
    </a>
  );
}
